import React, { CSSProperties } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { Candidate } from '../../../candidate/candidate'
import { BoardProvider, ColumnData } from '../../../hooks/use-board'
import { CandidateModal } from '../../../candidate/components/candidate-modal'
import { Column } from '../../column'
import { useAuth } from '../../../auth'
import { BoardContent } from './board-content'

export type DragData = {
    item: Candidate
    fromColumn: string
    index: number
}

export type DropLinePosition = {
    columnId: string
    index: number
}

export function Board({
    campaignId,
    candidateId,
    style,
    columns,
    height,
    selected,
    setSelected,
}: {
    campaignId?: string
    columns: Column[]
    candidateId?: string
    style?: React.CSSProperties
    height?: CSSProperties['maxHeight']
    selected: Record<string, boolean>
    setSelected: React.Dispatch<React.SetStateAction<Record<string, boolean>>>
}) {
    const navigate = useNavigate()
    const { showCandidateAttributes, showCandidatePhone } = useAuth()

    const initialColumns = columns.reduce((carry: ColumnData, column) => {
        carry[column.id] = {
            column,
        }

        return carry
    }, {})

    return (
        <BoardProvider
            selected={selected}
            setSelected={setSelected}
            showAttributes={showCandidateAttributes}
            showPhone={showCandidatePhone}
            campaignId={campaignId}
            initialColumns={{
                ...initialColumns,
            }}
        >
            <BoardContent
                style={style}
                height={height}
            />
            <CandidateModal
                candidateId={candidateId}
                open={!!candidateId}
                onCancel={() => {
                    navigate({
                        to: '.',
                        search: (search) => ({
                            ...search,
                            candidateId: undefined,
                        }),
                    })
                }}
            />
        </BoardProvider>
    )
}
